/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_CharactersInputs */

const en_translation_characters = /** @type {(inputs: Translation_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation Characters`)
};

const fr_translation_characters = /** @type {(inputs: Translation_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caractères de traduction`)
};

const de_translation_characters = /** @type {(inputs: Translation_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzungszeichen`)
};

const it_translation_characters = /** @type {(inputs: Translation_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personaggi della traduzione`)
};

const ru_translation_characters = /** @type {(inputs: Translation_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Символы перевода`)
};

const es_translation_characters = /** @type {(inputs: Translation_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres de traducción`)
};

const zh_cn2_translation_characters = /** @type {(inputs: Translation_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译字符`)
};

const ja_translation_characters = /** @type {(inputs: Translation_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳文字`)
};

const hi_translation_characters = /** @type {(inputs: Translation_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद वर्ण`)
};

const pt_pt2_translation_characters = /** @type {(inputs: Translation_CharactersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres de tradução`)
};

/**
* | output |
* | --- |
* | "Translation Characters" |
*
* @param {Translation_CharactersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_characters = /** @type {((inputs?: Translation_CharactersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_CharactersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_characters(inputs)
	if (locale === "de") return de_translation_characters(inputs)
	if (locale === "it") return it_translation_characters(inputs)
	if (locale === "ru") return ru_translation_characters(inputs)
	if (locale === "es") return es_translation_characters(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_characters(inputs)
	if (locale === "ja") return ja_translation_characters(inputs)
	if (locale === "hi") return hi_translation_characters(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_characters(inputs)
	return en_translation_characters(inputs)
});